import React from "react";
import clsx from "clsx";

import { ReactComponent as ArrowRightIcon } from "../../../../../assets/svg/arrow_right_single.svg";
import { ReactComponent as ClockIcon } from "../../../../../assets/svg/clock.svg";
import { ReactComponent as PinIcon } from "../../../../../assets/svg/pin.svg";
import { ReactComponent as ComingSoonIcon } from "../../../../../assets/svg/coming_soon.svg";
import styles from "../../SelectPage.module.scss";

interface IActionCardProps {
  title: string;
  pinText: string;
  time?: string;
  onClick?: () => void;
  href?: string;
  thumbnailUrl?: string;
  showComingSoon?: boolean;
  disabled?: boolean;
  isMaterialCard?: boolean;
}

const ActionCard: React.FC<IActionCardProps> = ({
  title,
  pinText,
  time,
  onClick,
  href,
  thumbnailUrl,
  showComingSoon,
  disabled,
  isMaterialCard,
}) => {
  const cardClasses = clsx(
    styles.actionCard,
    isMaterialCard && styles.materialCard,
    disabled && styles.disabledCard,
  );

  const content = (
    <>
      <div className={styles.cardTitleRow}>
        <span className={styles.cardTitle}>{title}</span>
        <ArrowRightIcon className={styles.arrowIcon} />
      </div>
      <div className={styles.cardTags}>
        {time && (
          <span className={clsx(styles.tag, styles.clock)}>
            <ClockIcon /> {time}
          </span>
        )}
        <span className={styles.tag}>
          <PinIcon /> {pinText}
        </span>
      </div>
      {showComingSoon ? (
        <ComingSoonIcon />
      ) : thumbnailUrl ? (
        <div className={styles.thumbnailWrapper}>
          <img src={thumbnailUrl} alt={title} className={styles.thumbnail} />
        </div>
      ) : null}
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={cardClasses}
        style={{ textDecoration: "none" }}
        onClick={onClick}
      >
        {content}
      </a>
    );
  }

  return (
    <div className={cardClasses} onClick={disabled ? undefined : onClick}>
      {content}
    </div>
  );
};

export default ActionCard;
